/**
 * A per-page-load session id. Sent as `x-dw-session` on /api/query and used to
 * open the live-tasks WebSocket, so the server pushes only *this* page's task
 * activity back to it (EXPERIMENT — see livebus.ts).
 */
export const SESSION_ID =
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2);
